// back/config/menuCategoryTemplates.js

export  const categoryTemplates = {
  restaurant: {
    label: "رستوران",
    categories: [
      { name: "غذاهای اصلی", items: [] },
      { name: "پیش‌غذا", items: [] },
      { name: "سالاد", items: [] },
      { name: "سوپ و آش", items: [] },
      { name: "کباب‌ها", items: [] },
      { name: "خورشت‌ها", items: [] },
      { name: "غذاهای دریایی", items: [] },
      { name: "غذاهای فرنگی", items: [] },
      { name: "پاستا", items: [] },
      { name: "منوی کودک", items: [] },
      { name: "مخلفات", items: [] },
      { name: "دسر", items: [] },
      { name: "نوشیدنی", items: [] },
      { name: "بازی‌ها", items: [] },
    ],
  },

  cafe: {
    label: "کافه",
    categories: [
      { name: "کافی‌شاپ", items: [] },
      { name: "نوشیدنی‌های گرم", items: [] },
      { name: "نوشیدنی‌های سرد", items: [] },
      { name: "قهوه‌های دمی", items: [] },
      { name: "چای و دمنوش", items: [] },
      { name: "شیک و اسموتی", items: [] },
      { name: "آبمیوه و لیموناد", items: [] },
      { name: "صبحانه", items: [] },
      { name: "سالاد", items: [] },
      { name: "ساندویچ و پنینی", items: [] },
      { name: "پاستا", items: [] },
      { name: "میان‌وعده", items: [] },
      { name: "دسر و کیک", items: [] },
      { name: "بازی‌ها", items: [] },
    ],
  },

  fastfood: {
    label: "فست‌فود",
    categories: [
      { name: "برگرها", items: [] },
      { name: "پیتزا", items: [] },
      { name: "ساندویچ", items: [] },
      { name: "سوخاری", items: [] },
      { name: "هات‌داگ", items: [] },
      { name: "سیب‌زمینی و فست‌فود", items: [] },
      { name: "پیش‌غذا", items: [] },
      { name: "سالاد", items: [] },
      { name: "منوی کودک", items: [] },
      { name: "سس‌ها", items: [] },
      { name: "نوشیدنی", items: [] },
      { name: "بازی‌ها", items: [] },
    ],
  },

  bakery: {
    label: "قنادی",
    categories: [
      { name: "نان و شیرینی", items: [] },
      { name: "شیرینی تر", items: [] },
      { name: "شیرینی خشک", items: [] },
      { name: "کیک‌ها و دسر", items: [] },
      { name: "کیک تولد", items: [] },
      { name: "شیرینی سنتی", items: [] },
      { name: "نان", items: [] },
      { name: "بستنی", items: [] },
      { name: "نوشیدنی‌ها", items: [] },
      { name: "بازی‌ها", items: [] },
    ],
  },
};
export default categoryTemplates;
